import { useState, useEffect } from "react";
import Sidebar from '../../../componente/sidebar/index.jsx';
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpTecido from "../../../componente/popup/index.jsx";
import PopUpCor from "../../../componente/popup/index.jsx";
import PopUpTamanho from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function CadProduto() {
    const [lista, setlista] = useState([]);
    const [abusca, setabusca] = useState("");
    const [showform, setshowform] = useState(false);

    const [codproduto, setCodProduto] = useState(0);
    const [modelo, setModelo] = useState("");
    const [valorserraria, setValorSerraria] = useState("");
    const [valormontagemgrade, setValorMontagemGrade] = useState("");
    const [valormarcenaria, setValorMarcenaria] = useState("");
    const [valorcolagemespuma, setValorColagemEspuma] = useState("");
    const [valorcortetecido, setValorCorteTecido] = useState("");
    const [valorcostura, setValorCostura] = useState("");
    const [valorenchimentoalmofada, setValorEnchimentoAlmofada] = useState("");
    const [valorcolagemtecido, setValorColagemTecido] = useState("");
    const [valorcoberta, setValorCoberta] = useState("");
    const [valorentrega, setValorEntrega] = useState("");
    const [ativo, setAtivo] = useState("");

    const [novo, setnovo] = useState(false);

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenTecido, setIsOpenTecido] = useState(false);
    const [isOpenCor, setIsOpenCor] = useState(false);
    const [isOpenTamanho, setIsOpenTamanho] = useState(false);

    const { user, selectedCompany, accessKey } = useAppContext(); // Acessa os dados do contexto   

    const [codtecido, setCodTecido] = useState(0);
    const [descricaotecido, setDescricaoTecido] = useState("");
    const [listaTecido, setListaTecido] = useState([]);
    const [codcor, setCodCor] = useState(0);
    const [descricaocor, setDescricaoCor] = useState("");
    const [listaCor, setListaCor] = useState([]);
    const [codtamanho, setCodTamanho] = useState(0);
    const [descricaotamanho, setDescricaoTamanho] = useState("");
    const [listaTamanho, setListaTamanho] = useState([]);

    const handleOpen = (cad) => {
        setCodProduto(cad.codproduto);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        Excluir();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleOpenTecido = (cad) => {
        setCodTecido(cad.codtecido);
        setIsOpenTecido(true);
    };

    const handleConfirmaTecido = () => {
        setIsOpenTecido(false);
        ExcluirTecido();
    };

    const handleCloseTecido = () => {
        setIsOpenTecido(false);
    };

    const handleOpenCor = (cad) => {
        setCodCor(cad.codcor);
        setIsOpenCor(true);
    };

    const handleConfirmaCor = () => {
        setIsOpenCor(false);
        ExcluirCor();
    };

    const handleCloseCor = () => {
        setIsOpenCor(false);
    };

    const handleOpenTamanho = (cad) => {
        setCodTamanho(cad.codtamanho);
        setIsOpenTamanho(true);
    };

    const handleConfirmaTamanho = () => {
        setIsOpenTamanho(false);
        ExcluirTamanho();
    };

    const handleCloseTamanho = () => {
        setIsOpenTamanho(false);
    };

    function ListarTecido() {
        api
            .get("v1/cadastro/produto/tecido", {
                params: {
                    codproduto
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaTecido(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarCor() {
        api
            .get("v1/cadastro/produto/cor", {
                params: {
                    codproduto
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaCor(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarTamanho() {
        api
            .get("v1/cadastro/produto/tamanho", {
                params: {
                    codproduto
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaTamanho(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarProduto() {
        api
            .get("v1/cadastro/produto", {
                params: {
                    busca: abusca,
                    codempresa: selectedCompany
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarProduto();
        },
        [abusca, selectedCompany]
    );

    function Cadastrar() {
        api
            .post(
                "v1/cadastro/produto",
                {
                    modelo,
                    valorserraria,
                    valormontagemgrade,
                    valormarcenaria,
                    valorcolagemespuma,
                    valorcortetecido,
                    valorcostura,
                    valorenchimentoalmofada,
                    valorcolagemtecido,
                    valorcoberta,
                    valorentrega,
                    ativo,
                    excluido: "N",
                    codempresa: selectedCompany,
                    codusuario: user.codusuario
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarProduto();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function CadastrarCor() {
        if (novo) {
            api
                .post(
                    "v1/cadastro/produto",
                    {
                        modelo,
                        valorserraria,
                        valormontagemgrade,
                        valormarcenaria,
                        valorcolagemespuma,
                        valorcortetecido,
                        valorcostura,
                        valorenchimentoalmofada,
                        valorcolagemtecido,
                        valorcoberta,
                        valorentrega,
                        ativo,
                        excluido: "N",
                        codempresa: selectedCompany,
                        codusuario: user.codusuario
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(function (response) {
                    setnovo(false);
                    setCodProduto(response.data.codproduto);

                    api
                        .post(
                            "v1/cadastro/produto/cor",
                            {
                                descricao: descricaocor,
                                codproduto: response.data.codproduto,
                                excluido: 'N'
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${accessKey}`,
                                },
                            }
                        )
                        .then(() => {
                            ListarCor();
                        })
                        .catch(function (err) {
                            console.log("ops! ocorreu um erro: " + err);
                        });
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        } else {
            api
                .post(
                    "v1/cadastro/produto/cor",
                    {
                        descricao: descricaocor,
                        codproduto,
                        excluido: 'N'
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(() => {
                    ListarCor();
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        }
    }

    function CadastrarTecido() {
        if (novo) {
            api
                .post(
                    "v1/cadastro/produto",
                    {
                        modelo,
                        valorserraria,
                        valormontagemgrade,
                        valormarcenaria,
                        valorcolagemespuma,
                        valorcortetecido,
                        valorcostura,
                        valorenchimentoalmofada,
                        valorcolagemtecido,
                        valorcoberta,
                        valorentrega,
                        ativo,
                        excluido: "N",
                        codempresa: selectedCompany,
                        codusuario: user.codusuario
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(function (response) {
                    setnovo(false);
                    setCodProduto(response.data.codproduto);

                    api
                        .post(
                            "v1/cadastro/produto/tecido",
                            {
                                descricao: descricaotecido,
                                codproduto: response.data.codproduto,
                                excluido: 'N'
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${accessKey}`,
                                },
                            }
                        )
                        .then(() => {
                            ListarTecido();
                        })
                        .catch(function (err) {
                            console.log("ops! ocorreu um erro: " + err);
                        });
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        } else {
            api
                .post(
                    "v1/cadastro/produto/tecido",
                    {
                        descricao: descricaotecido,
                        codproduto,
                        excluido: 'N'
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(() => {
                    ListarTecido();
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        }
    }

    function CadastrarTamanho() {
        if (novo) {
            api
                .post(
                    "v1/cadastro/produto",
                    {
                        modelo,
                        valorserraria,
                        valormontagemgrade,
                        valormarcenaria,
                        valorcolagemespuma,
                        valorcortetecido,
                        valorcostura,
                        valorenchimentoalmofada,
                        valorcolagemtecido,
                        valorcoberta,
                        valorentrega,
                        ativo,
                        excluido: "N",
                        codempresa: selectedCompany,
                        codusuario: user.codusuario
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(function (response) {
                    setnovo(false);
                    setCodProduto(response.data.codproduto);

                    api
                        .post(
                            "v1/cadastro/produto/tamanho",
                            {
                                descricao: descricaotamanho,
                                codproduto: response.data.codproduto,
                                excluido: 'N'
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${accessKey}`,
                                },
                            }
                        )
                        .then(() => {
                            ListarTamanho();
                        })
                        .catch(function (err) {
                            console.log("ops! ocorreu um erro: " + err);
                        });
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        } else {
            api
                .post(
                    "v1/cadastro/produto/tamanho",
                    {
                        descricao: descricaotamanho,
                        codproduto,
                        excluido: 'N'
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(() => {
                    ListarTamanho();
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        }
    }

    function Editar() {
        api
            .put(
                "v1/cadastro/produto",
                {
                    modelo,
                    valorserraria,
                    valormontagemgrade,
                    valormarcenaria,
                    valorcolagemespuma,
                    valorcortetecido,
                    valorcostura,
                    valorenchimentoalmofada,
                    valorcolagemtecido,
                    valorcoberta,
                    valorentrega,
                    ativo,
                    codproduto
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarProduto();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Excluir() {
        api
            .delete("v1/cadastro/produto", {
                params: {
                    codproduto,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarProduto();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ExcluirTecido() {
        api
            .delete("v1/cadastro/produto/tecido", {
                params: {
                    codtecido,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarTecido();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ExcluirCor() {
        api
            .delete("v1/cadastro/produto/cor", {
                params: {
                    codcor,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarCor();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ExcluirTamanho() {
        api
            .delete("v1/cadastro/produto/tamanho", {
                params: {
                    codtamanho,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarTamanho();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    function closeModal() {
        setshowform(false);
    }

    function openModalNovo() {
        setshowform(true);
        setnovo(true);

        setCodProduto(0);
        setModelo("");
        setValorSerraria(0);
        setValorMontagemGrade(0);
        setValorMarcenaria(0);
        setValorColagemEspuma(0);
        setValorCorteTecido(0);
        setValorCostura(0);
        setValorEnchimentoAlmofada(0);
        setValorColagemTecido(0);
        setValorCoberta(0);
        setValorEntrega(0);
        setAtivo("S");
    }

    function openModalEditar(cad) {
        setshowform(true);
        setnovo(false);

        setCodProduto(cad.codproduto);
        setModelo(cad.modelo);
        setValorSerraria(cad.valorserraria);
        setValorMontagemGrade(cad.valormontagemgrade);
        setValorMarcenaria(cad.valormarcenaria);
        setValorColagemEspuma(cad.valorcolagemespuma);
        setValorCorteTecido(cad.valorcortetecido);
        setValorCostura(cad.valorcostura);
        setValorEnchimentoAlmofada(cad.valorenchimentoalmofada);
        setValorColagemTecido(cad.valorcolagemtecido);
        setValorCoberta(cad.valorcoberta);
        setValorEntrega(cad.valorentrega);
        setAtivo(cad.ativo);

        ListarCor();
        ListarTamanho();
        ListarTecido();
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <div className="content-container">
                    <div className="container-fluid">
                        <div>
                            <div>
                                <PopUp isOpen={isOpen} onClose={handleClose}>
                                    <h2>Verificação</h2>
                                    <p>Tem certeza que deseja excluir esse registro?</p>

                                    <div className="row">
                                        <div className="col-12 mt-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2"
                                                onClick={handleConfirma}
                                            >
                                                Sim
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={handleClose}>
                                                Não
                                            </button>
                                        </div>
                                    </div>
                                </PopUp>

                                <PopUpTamanho isOpen={isOpenTamanho} onClose={handleCloseTamanho}>
                                    <h2>Verificação</h2>
                                    <p>Tem certeza que deseja excluir esse tamanho?</p>

                                    <div className="row">
                                        <div className="col-12 mt-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2"
                                                onClick={handleConfirmaTamanho}
                                            >
                                                Sim
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={handleCloseTamanho}>
                                                Não
                                            </button>
                                        </div>
                                    </div>
                                </PopUpTamanho>

                                <PopUpCor isOpen={isOpenCor} onClose={handleCloseCor}>
                                    <h2>Verificação</h2>
                                    <p>Tem certeza que deseja excluir essa cor?</p>

                                    <div className="row">
                                        <div className="col-12 mt-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2"
                                                onClick={handleConfirmaCor}
                                            >
                                                Sim
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={handleCloseCor}>
                                                Não
                                            </button>
                                        </div>
                                    </div>
                                </PopUpCor>

                                <PopUpTecido isOpen={isOpenTecido} onClose={handleCloseTecido}>
                                    <h2>Verificação</h2>
                                    <p>Tem certeza que deseja excluir esse tecido?</p>

                                    <div className="row">
                                        <div className="col-12 mt-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2"
                                                onClick={handleConfirmaTecido}
                                            >
                                                Sim
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={handleCloseTecido}>
                                                Não
                                            </button>
                                        </div>
                                    </div>
                                </PopUpTecido>
                            </div>

                            <Modal
                                isOpen={showform}
                                onRequestClose={closeModal}
                                overlayClassName="modal-overlay"
                                className="modal-content modal-xl"
                            >
                                <div className="container-fluid h-100">
                                    <div className="modal-header">
                                        {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                        <button type="button" className="btn-close" onClick={closeModal}></button>
                                    </div>

                                    <div className="modal-body">
                                        <form>
                                            <div className="row">
                                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                                    <label htmlFor="modelo" className="form-label">
                                                        Modelo
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="modelo"
                                                        className="form-control"
                                                        placeholder="Modelo"
                                                        value={modelo}
                                                        onChange={(e) => setModelo(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valorserraria" className="form-label">
                                                        Valor Serraria
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valorserraria"
                                                        className="form-control"
                                                        placeholder="Valor Serraria"
                                                        value={valorserraria}
                                                        onChange={(e) => setValorSerraria(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valormontagemgrade" className="form-label">
                                                        Valor Montagem Grade
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valormontagemgrade"
                                                        className="form-control"
                                                        placeholder="Valor Montagem Grade"
                                                        value={valormontagemgrade}
                                                        onChange={(e) => setValorMontagemGrade(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valormarcenaria" className="form-label">
                                                        Valor Marcenária
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valormarcenaria"
                                                        className="form-control"
                                                        placeholder="Valor Marcenária"
                                                        value={valormarcenaria}
                                                        onChange={(e) => setValorMarcenaria(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valorcolagemespuma" className="form-label">
                                                        Valor Colagem Espuma
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valorcolagemespuma"
                                                        className="form-control"
                                                        placeholder="Valor Colagem Espuma"
                                                        value={valorcolagemespuma}
                                                        onChange={(e) => setValorColagemEspuma(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valorcortetecido" className="form-label">
                                                        Valor Corte Tecido
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valorcortetecido"
                                                        className="form-control"
                                                        placeholder="Valor Corte Tecido"
                                                        value={valorcortetecido}
                                                        onChange={(e) => setValorCorteTecido(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valorcostura" className="form-label">
                                                        Valor Costura
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valorcostura"
                                                        className="form-control"
                                                        placeholder="Valor Costura"
                                                        value={valorcostura}
                                                        onChange={(e) => setValorCostura(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valorenchimentoalmofada" className="form-label">
                                                        Valor Enchimento Almofada
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valorenchimentoalmofada"
                                                        className="form-control"
                                                        placeholder="Valor Enchimento Almofada"
                                                        value={valorenchimentoalmofada}
                                                        onChange={(e) => setValorEnchimentoAlmofada(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valorcolagemtecido" className="form-label">
                                                        Valor Colagem Tecido
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valorcolagemtecido"
                                                        className="form-control"
                                                        placeholder="Valor Colagem Tecido"
                                                        value={valorcolagemtecido}
                                                        onChange={(e) => setValorColagemTecido(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valorcoberta" className="form-label">
                                                        Valor Coberta
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valorcoberta"
                                                        className="form-control"
                                                        placeholder="Valor Coberta"
                                                        value={valorcoberta}
                                                        onChange={(e) => setValorCoberta(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="valorentrega" className="form-label">
                                                        Valor Entrega
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="valorentrega"
                                                        className="form-control"
                                                        placeholder="Valor Entrega"
                                                        value={valorentrega}
                                                        onChange={(e) => setValorEntrega(e.target.valueAsNumber)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                    <div>
                                                        <label htmlFor="ativo1" className="form-label">
                                                            Ativo
                                                        </label>
                                                        <br />
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="ativo"
                                                                value="S"
                                                                onChange={(e) => setAtivo(e.target.value)}
                                                                checked={ativo === "S"}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                for="inlineRadio1"
                                                            >
                                                                Sim
                                                            </label>
                                                        </div>

                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="ativo"
                                                                value="N"
                                                                onChange={(e) => setAtivo(e.target.value)}
                                                                checked={ativo === "N"}
                                                            />
                                                            <label className="form-check-label" htmlfor="ativo2">
                                                                Não
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                <hr />
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                                    <div className="row d-flex text-center"><h5>Tamanho</h5></div>
                                                    <div className="row">
                                                        <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                                            <label htmlFor="descricaotamanho" className="form-label">
                                                                Descrição
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="descricaotamanho"
                                                                className="form-control"
                                                                placeholder="Descrição"
                                                                value={descricaotamanho}
                                                                onChange={(e) => setDescricaoTamanho(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-success btnnovo"
                                                                onClick={() => CadastrarTamanho()}
                                                            >
                                                                Add
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="row tabela">
                                                        <table className="table table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Descrição</th>
                                                                    <th className="acao">Ações</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {listaTamanho.map(function (item, index) {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <th>{item.descricao}</th>
                                                                            <th>
                                                                                <div className="d-flex justify-content-center">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn fa-solid fa-trash"
                                                                                        onClick={() => handleOpenTamanho(item)}
                                                                                    ></button>
                                                                                </div>
                                                                            </th>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th colSpan={2}>Quantidade de Registros: {listaTamanho.length}</th>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                                    <div className="row d-flex text-center"><h5>Tecido</h5></div>
                                                    <div className="row">
                                                        <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                                            <label htmlFor="descricaotecido" className="form-label">
                                                                Descrição
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="descricaotecido"
                                                                className="form-control"
                                                                placeholder="Descrição"
                                                                value={descricaotecido}
                                                                onChange={(e) => setDescricaoTecido(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-success btnnovo"
                                                                onClick={() => CadastrarTecido()}
                                                            >
                                                                Add
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="row tabela">
                                                        <table className="table table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Descrição</th>
                                                                    <th className="acao">Ações</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {listaTecido.map(function (item, index) {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <th>{item.descricao}</th>
                                                                            <th>
                                                                                <div className="d-flex justify-content-center">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn fa-solid fa-trash"
                                                                                        onClick={() => handleOpenTecido(item)}
                                                                                    ></button>
                                                                                </div>
                                                                            </th>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th colSpan={2}>Quantidade de Registros: {listaTecido.length}</th>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                                    <div className="row d-flex text-center"><h5>Cor</h5></div>
                                                    <div className="row">
                                                        <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                                            <label htmlFor="descricaocor" className="form-label">
                                                                Descrição
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="descricaocor"
                                                                className="form-control"
                                                                placeholder="Descrição"
                                                                value={descricaocor}
                                                                onChange={(e) => setDescricaoCor(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-success btnnovo"
                                                                onClick={() => CadastrarCor()}
                                                            >
                                                                Add
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="row tabela">
                                                        <table className="table table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Descrição</th>
                                                                    <th className="acao">Ações</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {listaCor.map(function (item, index) {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <th>{item.descricao}</th>
                                                                            <th>
                                                                                <div className="d-flex justify-content-center">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn fa-solid fa-trash"
                                                                                        onClick={() => handleOpenCor(item)}
                                                                                    ></button>
                                                                                </div>
                                                                            </th>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th colSpan={2}>Quantidade de Registros: {listaCor.length}</th>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-danger" onClick={closeModal}>
                                            Cancelar
                                        </button>
                                        <button type="button" className="btn btn-success" onClick={Salvar}>
                                            Salvar
                                        </button>

                                    </div>
                                </div>
                            </Modal>
                        </div>

                        <div className="row">
                            <h1 className="ms-4">Cadastro de Produto</h1>
                            <p className="ms-4">Rotina para cadastrar os produtos</p>
                            <hr />
                        </div>

                        <div className="row">
                            <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                <label className="form-label" htmlFor="busca">
                                    Busque aqui
                                </label>
                                <input
                                    type="text"
                                    placeholder="Buscar por: Código ou Modelo"
                                    name="busca"
                                    id="busca"
                                    className="form-control"
                                    value={abusca}
                                    onChange={(e) => setabusca(e.target.value)}
                                />
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
                                <button
                                    type="button"
                                    className="btn btn-success btnnovo"
                                    onClick={() => openModalNovo()}
                                >
                                    Novo
                                </button>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <hr />
                        </div>

                        <div className="row tabela">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Modelo</th>
                                        <th className="acao">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lista.map(function (item, index) {
                                        return (
                                            <tr key={index}>
                                                <th>{item.codproduto}</th>
                                                <th>{item.modelo}</th>
                                                <th>
                                                    <div className="d-flex justify-content-center">
                                                        <button
                                                            type="button"
                                                            className="btn fa-regular fa-pen-to-square"
                                                            onClick={() => openModalEditar(item)}
                                                        ></button>
                                                        <button
                                                            type="button"
                                                            className="btn fa-solid fa-trash"
                                                            onClick={() => handleOpen(item)}
                                                        ></button>
                                                    </div>
                                                </th>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={3}>Quantidade de Registros: {lista.length}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CadProduto;
